<template>
  <v-chart
    :forceFit="true"
    :height="height"
    :padding="padding"
    :data="dataz"
    :scale="scale"
    :filter="filter"
  >
    <v-coord
      type="theta"
      :innerRadius=".7"
      :radius=".95"
    ></v-coord>
    <v-tooltip
      :showTitle="false"
      :containerTpl="containerTplTooltip"
      :itemTpl="itemTplTooltip"
    ></v-tooltip>
    <v-legend
      :useHtml="true"
      position="right"
      :reactive="true"
      :containerTpl="containerTplLegend"
      :itemTpl="itemTplLegend"
      :offset="offset"
    ></v-legend>
    <v-stack-interval
      position="percent"
      :color="color"
      :vStyle="style"
    ></v-stack-interval>
    <v-guide :type="guideOpts.type"
             :position="guideOpts.position"
              :html="guideOpts.html"/>

  </v-chart>
</template>

<script>
const DataSet = require('@antv/data-set');

const setStyle = () => {
  const id = 'legend-html';
  if (document.getElementById(id)) {
    return;
  }
  const styleTxt = `
        #canvas .g2-tooltip {
        position:absolute;
        visibility:hidden;
        border-style:solid;
        white-space:nowrap;
        z-index:9;
        transition:left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        background-color:rgb(255, 255, 255);
        border-width:1px;
        border-color: #999;
        border-radius:4px;
        color: #444;
        font-style:normal;
        font-variant:normal;
        font-weight:normal;
        font-stretch:normal;
        font-size:14px;
        font-family:sans-serif;
        line-height:21px;
        padding:5px;
        }

        #canvas .g2-tooltip-list {
        margin: 5px ;
        list-style-type:none;
        padding:0;
        }
        #canvas .g2-legend {
        top: 45%!important;
        }
        .g2-legend{
            position:absolute;
            max-width:none !important;
        }
        .g2-legend-list{
            list-style:none;
            margin:0;
            padding:0;
        }
        .g2-legend-list-item{
            cursor:pointer;
            font-size:14px;
        }
    `;
  const style = document.createElement('style');
  style.setAttribute('id', id);
  style.innerHTML = styleTxt;
  document.getElementsByTagName('head')[0].appendChild(style);
};
setStyle();

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    height:{
      type:Number,
      default:500
    }
  },
  computed:{
  },
  watch:{
    dataSource:{
      handler(newVal, oldVal){
        this.echartData = newVal || []
        this.init()
      },
      deep: true
    }
  },
  data() {
    return {
      dataz: null,
      guideOpts : {
        type: 'html',
        position: ['50%', '50%'],
        html: `<div><p style="font-size: 16px;color: rgba(0, 0, 0, 0.427);text-align: center"></p><p style="font-size: 24px;text-align: center;font-weight:bold"></p></div>`
      },
      echartData:[],
      offset:[0,0],
      scale:[
        {
          dataKey: 'percent',
          formatter: function formatter(val) {
            val = (val * 100).toFixed(2) + '%';
            return val;
          },
          nice: false
        }
      ],
      filter:{
        dataKey: 'months',
        callback: function(val) {
          return val !== 'UK';
        }
      },
      containerTplTooltip:`<div class="g2-tooltip"><ul class="g2-tooltip-list"></ul></div>`,
      itemTplTooltip:'<li data-index={index}><span style="color:{color}">{name}:</span>{value}</li>',
      containerTplLegend:`<div class="g2-legend"> <table class="g2-legend-list"></table> </div>`,
      color:[
        'months',
        ['#67b7dc', '#84b761', '#fdd400', '#cc4748', '#cd82ad', '#2f4074', '#448e4d', '#b7b83f', '#b9783f']
      ],
      label:[
        'percent',
        {
          formatter: function formatter(val, item) {
            return item.months + ': ' + val;
          }
        }
      ],
      style:{
        // lineWidth: 2,
        stroke: '#fff'
      },
      padding:[10, 250, 25, 0],
    };
  },
  mounted () {
    console.log("data:",this.dataSource)
    this.echartData = this.dataSource || []
    this.init()
  },
  methods:{
    init(){
      const ds = new DataSet();
      this.dataz = ds.createView().source(this.dataSource).transform({
        type: 'percent',
        field: 'sales',
        dimension: 'months',
        as: 'percent'
      });
      this.guideOpts.html = this.title;
    },

    itemTplLegend(value, color, checked, index){
      if(!this.dataz) return
      const obj = this.dataz.rows[index];
      const percent = (obj.percent * 100).toFixed(2) + '%';
      checked = checked ? 'checked' : 'unChecked';
      return '<tr class="g2-legend-list-item item-' + index + ' ' + checked + '" data-value="' + value + '" data-color=' + color + ' >' + '<td style="width:120px;"><i class="g2-legend-marker" style="width:10px;height:10px;display:inline-block;margin-right:10px;background-color:' + color + ';"></i>' + '<span class="g2-legend-text" style="color: #666">' + value + '</span></td>' + '<td style="text-align: right">' + percent + '</td>' + '<td style="text-align: right;color: #666;width:80px">¥ ' + obj.sales + '</td>' + '</tr>';
    },
  }
};

</script>